<template>
    <header class="header">
        <div class="auto">
            <div class="top">
                <router-link class="logo" to="/">
                    <img src="./img/logo.png" alt="smiletotravel" />
                </router-link>
                <el-button class="menu" type="info" plain size="small" @click="navHandler()">
                    MENU
                    <i class="fas fa-bars"></i>
                </el-button>
            </div>
            <transition name="fade">
                <nav class="nav" v-if="navShow || Number(screenWidth) >= 1208">
                    <router-link class="btn" to="/order" @click.native="navHidden()">線上訂車 ORDER CAR</router-link>
                    <router-link class="btn" to="/qa" @click.native="navHidden()">常見問題 Q&A</router-link>
                    <router-link class="btn" to="/track" @click.native="navHidden()">訂單查詢 ORDER TRACKING</router-link>
                    <router-link class="btn" to="/suggest" @click.native="navHidden()">評價司機 SUGGEST</router-link>
                </nav>
            </transition>
        </div>
    </header>
</template>
<script>
export default {
    name: 'headerBar',
    data() {
        return {};
    },
    computed: {
        navShow() {
            return this.$store.state.navShow;
        },
        screenWidth: {
            get() {
                return this.$store.state.screenWidth;
            },
            set(val) {
                this.$store.commit('SCREENWIDTH', val);
            }
        }
    },
    methods: {
        navHandler() {
            this.$store.commit('NAVHANDLER');
        },
        navHidden() {
            this.$store.commit('NAVHANDLER', false);
        }
    },
    mounted() {
        this.screenWidth = document.body.clientWidth;
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })();
        };
    }
};
</script>

<style lang="scss" scoped>
.header {
    font-family: '微軟正黑體', sans-serif;
    background-color: white;
    width: 100%;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 100;
    .auto {
        width: 1440px;
        margin: auto;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        @media screen and (max-width: 1440px) {
            width: 1224px;
        }
        @media screen and (max-width: 1224px) {
            width: 96%;
        }
        // 最上面
        .top {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 56px;
            // logo
            .logo {
                width: 120px;
                img {
                    height: 40px;
                }
            }
            // 菜單按鈕
            .menu {
                display: none;
            }
        }
        // 連結
        .nav {
            display: flex;
            align-items: center;
            height: 56px;
            .btn {
                font-size: 12px;
                line-height: 56px;
                padding: 0 24px;
                color: $title;
                transition: 0.6s;
                &:hover {
                    color: $deep-green;
                }
            }
        }
    }
}
@media screen and (max-width: 1224px) {
    .header {
        .auto {
            flex-direction: column;
            .top {
                .menu {
                    display: block;
                    font-size: 12px;
                }
            }
            .nav {
                height: auto;
                flex-direction: column;
                align-items: flex-start;
                .btn {
                    width: 100%;
                    padding: 0;
                }
            }
        }
    }
}
</style>
